import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import * as OrdersActions from '../../../state/orders/orders.actions';
import {
  selectFilteredUserOrders, // <-- CAMBIO
  selectUserOrdersLoading,
  selectUserOrdersTotalPages,
  selectUserOrdersCurrentPage,
} from '../../../state/orders/orders.selectors';
import { Order } from '../../../common/order';
import { Page } from '../../../common/page';
import { OrderStatusStylePipe } from '@app/pipes/order-status-style.pipe';
import { GalaxyButtonDirective } from '@app/directives/galaxy-button.directive';
import { GalaxyRippleDirective } from '@app/directives/galaxy-ripple.directive';
import { GalaxyCardComponent } from '@app/components/ui/galaxy-card/galaxy-card.component';
import { InteractiveCrystalDirective } from '@app/directives/interactive-crystal.directive';
import { AnimateStaggerDirective } from '@app/directives/animate-stagger.directive';
import { GalaxySkeletonComponent } from '@app/components/ui/galaxy-skeleton/galaxy-skeleton.component';

@Component({
  selector: 'app-order-history',
  imports: [
    CommonModule,
    RouterModule,
    OrderStatusStylePipe,
    GalaxyButtonDirective,
    GalaxyRippleDirective,
    GalaxyCardComponent,
    InteractiveCrystalDirective,
    AnimateStaggerDirective,
    GalaxySkeletonComponent,
  ],
  templateUrl: './order-history.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./order-history.component.css'],
})
export class OrderHistoryComponent implements OnInit {
  private store = inject(Store);

  orders$: Observable<Order[]> = this.store.select(selectFilteredUserOrders); // <-- CAMBIO
  isLoading$: Observable<boolean> = this.store.select(selectUserOrdersLoading);
  currentPage$: Observable<number> = this.store.select(
    selectUserOrdersCurrentPage,
  );
  totalPages$: Observable<number> = this.store.select(
    selectUserOrdersTotalPages,
  );

  pageSize = 10;

  ngOnInit(): void {
    this.loadOrderHistory(0);
  }

  loadOrderHistory(page: number): void {
    this.store.dispatch(
      OrdersActions.loadUserOrders({ page, size: this.pageSize }),
    );
  }

  goToPreviousPage(): void {
    this.currentPage$.pipe(take(1)).subscribe((page) => {
      if (page > 0) {
        this.loadOrderHistory(page - 1);
      }
    });
  }

  goToNextPage(): void {
    this.currentPage$.pipe(take(1)).subscribe((page) => {
      this.loadOrderHistory(page + 1);
    });
  }
}
